import { ROUTES } from '../../config/routes';

// Product identity and destinations are shared by all content pages.
export const products = [
  {
    id: 'hi-cps', name: 'Hi-CPS', fullName: 'Hanwha Intelligent CNC Prognostic System',
    path: ROUTES.hicpsIntro, translationId: 'hicps', className: 'hicps-intro-page',
    tags: ['monitoring', 'analysis', 'remote', 'notification'],
    actions: [
      { label: 'open', href: 'https://hicps.org', external: true },
      { label: 'resources', href: ROUTES.resources },
    ],
  },
  {
    id: 'pg-solution', name: 'PG-Solution', fullName: 'Programming & Simulation Solution',
    path: ROUTES.pgSolutionIntro, translationId: 'pgSolution', className: 'pg-solution-page',
    tags: ['programming', 'simulation', 'validation', 'optimization'],
    actions: [
      { label: 'download', href: ROUTES.resources },
      { label: 'resources', href: ROUTES.resources },
    ],
  },
  {
    id: 'hi-link', name: 'Hi-Link', fullName: 'High intelligence Link',
    path: ROUTES.hiLinkIntro, translationId: 'hiLink', className: 'hilink-page',
    tags: ['mes', 'monitoring', 'module', 'remote'],
    actions: [
      { label: 'resources', href: ROUTES.resources },
      { label: 'contact', href: ROUTES.contact },
    ],
  },
];

export function getProduct(id) {
  const product = products.find(item => item.id === id);
  if (!product) throw new Error(`Unknown product: ${id}`);
  return product;
}
